import React from 'react';
import { Download } from 'lucide-react';
import { SearchInput } from '../findings/filters/SearchInput';
import { FilterSelect } from '../findings/filters/FilterSelect';
import { FilterButton } from '../findings/filters/FilterButton';

interface WebAppFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedTech: string;
  onTechChange: (tech: string) => void;
  selectedStatus: number;
  onStatusChange: (status: number) => void;
  onExport?: () => void;
}

const techOptions = [
  { value: 'all', label: 'All Technologies' },
  { value: 'react', label: 'React', color: 'text-blue-500' },
  { value: 'vue', label: 'Vue.js', color: 'text-emerald-500' },
  { value: 'angular', label: 'Angular', color: 'text-red-500' },
  { value: 'node', label: 'Node.js', color: 'text-green-500' },
  { value: 'python', label: 'Python', color: 'text-yellow-500' },
  { value: 'dotnet', label: '.NET', color: 'text-purple-500' }
];

const statusOptions = [
  { value: '0', label: 'All Statuses' },
  { value: '1', label: 'Active', color: 'text-emerald-500' },
  { value: '2', label: 'Maintenance', color: 'text-yellow-500' },
  { value: '3', label: 'Inactive', color: 'text-gray-500' },
  { value: '4', label: 'Vulnerable', color: 'text-red-500' }
];

export const WebAppFilters: React.FC<WebAppFiltersProps> = ({
  searchQuery,
  onSearchChange,
  selectedTech,
  onTechChange,
  selectedStatus,
  onStatusChange,
  onExport
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        {/* Search */}
        <div className="flex-1">
          <SearchInput
            value={searchQuery}
            onChange={onSearchChange}
            placeholder="Search web applications..."
          />
        </div>

        {/* Quick Filters */}
        {/* <div className="flex flex-wrap items-center gap-4">
          

          {onExport && (
            <button
              onClick={onExport}
              className="flex items-center space-x-2 px-4 py-2 bg-blue-500/10 text-blue-500 rounded-lg hover:bg-blue-500/20 transition-colors"
            >
              <Download className="h-4 w-4" />
              <span className="text-sm">Export</span>
            </button>
          )}
        </div> */}
        <FilterSelect
          value={selectedStatus?.toString() || 'no_filter'}
          onValueChange={(value) => onStatusChange(value === 'no_filter' ? 0 : Number(value))}
          options={statusOptions}
          placeholder="Status"
          label="Status"
        />
      </div>

      {/* Active Filters */}
      {/* {(selectedTech !== 'all' || selectedStatus !== 'all') && (
        <div className="flex items-center gap-2 text-sm text-gray-400">
          <span>Active filters:</span>
          {selectedTech !== 'all' && (
            <span className="px-2 py-1 bg-blue-500/10 text-blue-500 rounded-md">
              {techOptions.find(opt => opt.value === selectedTech)?.label}
            </span>
          )}
          {selectedStatus !== 'all' && (
            <span className="px-2 py-1 bg-blue-500/10 text-blue-500 rounded-md">
              {statusOptions.find(opt => opt.value === selectedStatus)?.label}
            </span>
          )}
        </div>
      )} */}
    </div>
  );
};